import { render } from "./Almacenes.vue?vue&type=template&id=182b31b4&scoped=true"
import script from "./Almacenes.vue?vue&type=script&lang=js"
export * from "./Almacenes.vue?vue&type=script&lang=js"

import "./Almacenes.vue?vue&type=style&index=0&id=182b31b4&scoped=true&lang=scss"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182b31b4"]])

export default __exports__